import type { FamilySpecsModelSnapshot } from "../types";
import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readObjectArray,
  readString,
  splitKnown,
} from "../utils";
import { SpecsFamilyVersionModel } from "./SpecsFamilyVersionModel";

export class SpecsFamilyModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    name: { label: "Name", fieldType: "text" },
    defaultVersion: { label: "Default version", fieldType: "text" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 8 },
  };

  name!: string;
  defaultVersion!: string;
  versions!: SpecsFamilyVersionModel[];
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("name", "");
    this.defineObservableValue("defaultVersion", "");
    this.defineObservableValue("versions", []);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "family");
    this.name = readString(source, "name");
    this.defaultVersion = readString(source, "defaultVersion");
    this.versions = readObjectArray(source, "versions").map((version) =>
      new SpecsFamilyVersionModel().restore(version)
    );
    this.extra = splitKnown(source, ["name", "defaultVersion", "versions"]);
    return this;
  }

  save(): FamilySpecsModelSnapshot {
    return {
      ...cloneValue(this.extra),
      name: this.name,
      ...(this.defaultVersion ? { defaultVersion: this.defaultVersion } : {}),
      versions: this.versions.map((version) => version.save()),
    };
  }
}
